import { Link } from 'react-router-dom';
import PageTransition from '../components/PageTransition';
import { useSEO } from '../hooks/useSEO';
import { PAGE_SEO } from '../utils/seo';

function FloatingOrb({
  color,
  size,
  top,
  left,
}: {
  color: string;
  size: number;
  top: string;
  left: string;
}) {
  return (
    <div
      className="hero-orb"
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: color,
        top,
        left,
      }}
      aria-hidden="true"
    />
  );
}

export default function NotFoundPage() {
  // Apply SEO
  useSEO(PAGE_SEO.notFound);
  return (
    <PageTransition>
      <section
        className="not-found-section"
        style={{
          minHeight: '80vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Animated gradient orbs for atmosphere */}
        <div className="hero-orbs" aria-hidden="true" style={{ position: 'absolute', inset: 0 }}>
          <FloatingOrb
            color="rgba(30, 215, 96, 0.08)"
            size={300}
            top="15%"
            left="10%"
          />
          <FloatingOrb
            color="rgba(83, 157, 245, 0.06)"
            size={250}
            top="50%"
            left="70%"
          />
          <FloatingOrb
            color="rgba(255, 164, 43, 0.05)"
            size={200}
            top="70%"
            left="25%"
          />
        </div>

        <div style={{ position: 'relative', zIndex: 1, textAlign: 'center' }}>
          <span
            className="h-hero"
            style={{
              color: 'var(--accent-green)',
              display: 'block',
              marginBottom: 'var(--space-4)',
              fontSize: 'clamp(4rem, 12vw, 8rem)',
            }}
          >
            404
          </span>
          <h2 className="h-1" style={{ marginBottom: 'var(--space-4)' }}>
            Page not found
          </h2>
          <p
            className="body-lg"
            style={{
              color: 'var(--text-secondary)',
              maxWidth: '480px',
              margin: '0 auto var(--space-8)',
            }}
          >
            The page you&apos;re looking for doesn&apos;t exist or has been
            moved.
          </p>
          <Link to="/" className="btn btn--primary btn--large">
            Back to Home
          </Link>
        </div>
      </section>
    </PageTransition>
  );
}
